"use client";
import ProductCardTabsAndPillsByUUIDClient from "@/components/ProductCardListWrapper/variants/ProductCardTabsAndPillsByUUID/ProductCardTabsAndPillsByUUIDClient";
import type { ProductCardTabsAndPillsByUUIDProps } from "@/components/ProductCardListWrapper/variants/ProductCardTabsAndPillsByUUID/types";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import MonarchResolver from "@/monarch/MonarchResolver";
import type {
  TrendingOnEdxTestData,
  TrendingOnEdxTestResult,
} from "@/monarch/rules/trendingOnEdx/types";
import type { Category } from "./types";
import getCategoriesWithoutCourses from "./utils/getCategoriesWithoutCourses";

const getTestCategories = (
  testData: TrendingOnEdxTestData,
  categories: Category[],
) => {
  const { enableTest, showCourses, tabOrder } = testData;
  if (!enableTest) {
    return getCategoriesWithoutCourses(categories);
  }
  const sortedCategories = categories.sort((a, b) => {
    const orderA = tabOrder[a.key];
    const orderB = tabOrder[b.key];
    return orderA - orderB;
  });
  return showCourses
    ? sortedCategories
    : getCategoriesWithoutCourses(sortedCategories);
};

function TestComponent(props: ProductCardTabsAndPillsByUUIDProps) {
  return (
    <MonarchDataConsumer<TrendingOnEdxTestResult>
      experimentKey="useTrendingOnEdx"
      render={(testResult) => {
        const { data } = testResult;
        const { categories } = props;
        if (!data || !categories) {
          return (
            <ProductCardTabsAndPillsByUUIDClient
              {...props}
              categories={
                categories
                  ? getCategoriesWithoutCourses(categories)
                  : categories
              }
            />
          );
        }
        const testCategories = getTestCategories(data, categories);
        return (
          <ProductCardTabsAndPillsByUUIDClient
            {...props}
            categories={testCategories}
          />
        );
      }}
    />
  );
}

export default function ProductCardTabsAndPillsByUUIDWrapper(
  props: ProductCardTabsAndPillsByUUIDProps,
) {
  const { categories } = props;
  return (
    <MonarchResolver<TrendingOnEdxTestResult>
      experimentKey="useTrendingOnEdx"
      variants={{
        control: (
          <ProductCardTabsAndPillsByUUIDClient
            {...props}
            categories={
              categories ? getCategoriesWithoutCourses(categories) : categories
            }
          />
        ),
        test: <TestComponent {...props} />,
      }}
      fallbackVariant="control"
    />
  );
}
